<template>
  <div>
    <v-layout>
      <v-flex xs8 offset-xs4>
        <v-layout>
          <v-flex shrink>
            <OpenCreativePage />
          </v-flex>
          <v-flex shrink d-flex align-center>
            <RefreshCreativePage
              @onClick="reloadCreatives"
              :disabled="reloadable"
            />
          </v-flex>
          <v-flex shrink align-center style="margin-left: 20px">
            <StatusSelect
              v-model="optionForShowCreatives"
              style="width: 180px;"
            />
          </v-flex>
          <v-flex shrink d-flex align-center>
            <v-tooltip ref="unstackButton" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  :disabled="visibleStackedCreatives.length === 0"
                  :loading="loadingChoices || loadingStack"
                  @click="unstackAllCreatives"
                  small
                  icon
                >
                  <v-icon small>close</v-icon>
                </v-btn>
              </template>
              <span>配信クリエイティブを空にする</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <AppStackSelector
      @stack="stackSelectedCreatives"
      @unstack="unstackSelectedCreatives"
      :disabled-stack="!creativeFolder || visibleCreatives.length === 0"
      :disabled-unstack="stackedCreatives.length === 0"
      :choices-width="600"
      :stack-width="300"
      :height="height"
    >
      <template v-slot:choices>
        <v-layout>
          <v-flex xs6>
            <AppScrollContainer :height="height" title="保存先フォルダ">
              <FolderSelector v-model="creativeFolder" :resources="resources" />
            </AppScrollContainer>
          </v-flex>
          <v-divider vertical />
          <v-flex xs6>
            <AppScrollContainer :height="height" title="クリエイティブ">
              <template v-if="creativeFolder">
                <CreativeTable
                  :items="visibleCreatives"
                  :selected-items="selectedCreatives"
                  :loading="loadingChoices"
                  @select="selectItem"
                  @perform="instantStackItem"
                />
              </template>
              <template v-else>
                <div class="pa-2">保存先フォルダを選択してください。</div>
              </template>
            </AppScrollContainer>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:stack>
        <AppScrollContainer :height="height" title="配信クリエイティブ">
          <CreativeTable
            :items="stackedCreatives"
            :selected-items="selectedCreatives"
            :loading="loadingStack"
            @select="selectItem"
            @perform="instantUnstackItem"
            empty-text="フォルダを選択し、クリエイティブを追加してください"
          />
        </AppScrollContainer>
      </template>
    </AppStackSelector>
  </div>
</template>

<script>
import CreativeTable from './CampaignModalPageCreativeSelectorCreativeTable'
import FolderSelector from '../Creative/FolderSelector.vue'
import StatusSelect, {
  StatusOptions,
} from './CampaignModalPageCreativeStatusSelect'
import OpenCreativePage from './CampaignModalPageCreativeOpenCreativePage'
import RefreshCreativePage from './CampaignModalPageCreativeRefreshCreativePage'
import unionBy from 'lodash/unionBy'
import differenceBy from 'lodash/differenceBy'
import { CreativeRepository, CreativeTypes } from '@/models/Creative'
import { Form } from '@/models/CampaignOperation/'

export default {
  name: 'CampaignModalPageCreativeSelector',
  components: {
    FolderSelector,
    StatusSelect,
    CreativeTable,
    OpenCreativePage,
    RefreshCreativePage,
  },
  props: {
    resources: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    creativeType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      creativeFolder: null,
      creatives: [],
      stackedCreatives: [],
      selectedCreatives: [],
      optionForShowCreatives: StatusOptions.ACTIVE_ONLY,
      loadingChoices: false,
      loadingStack: false,
      height: 300,
    }
  },
  computed: {
    advertiser() {
      const [advertiser] = this.resources
      return advertiser
    },
    visibleFilter() {
      return c =>
        this.optionForShowCreatives === StatusOptions.ACTIVE_ONLY
          ? c.isActive
          : true
    },
    visibleCreatives() {
      return differenceBy(this.creatives, this.stackedCreatives, 'id').filter(
        this.visibleFilter,
      )
    },
    visibleStackedCreatives() {
      return this.stackedCreatives.filter(this.visibleFilter)
    },
    reloadable() {
      return this.creativeFolder !== null || this.value.length > 0
    },
    creativeTypes() {
      switch (this.creativeType) {
        case CreativeTypes.BANNER: {
          return [CreativeTypes.BANNER, CreativeTypes.THREE_PAS]
        }
        case CreativeTypes.INFEED: {
          return [CreativeTypes.INFEED]
        }
        case CreativeTypes.VIDEO: {
          return [CreativeTypes.VIDEO]
        }
        default: {
          throw new Error(`想定しない creativeType です: ${this.creativeType}`)
        }
      }
    },
  },
  watch: {
    creativeFolder(folder) {
      if (folder) {
        this.fetchCreatives()
      }
    },
  },
  created() {
    if (this.value.length > 0) {
      this.fetchStackedCreatives()
    }
  },
  methods: {
    isSelected(item) {
      return this.selectedCreatives.find(i => i.id === item.id) != null
    },
    /**
     * 選択可能なのは1つだけ
     */
    selectItem(item) {
      this.$emit('select', item)
      if (this.isSelected(item)) {
        this.selectedCreatives = []
      } else {
        this.selectedCreatives = [item]
      }
    },
    stackSelectedCreatives() {
      this.stackedCreatives = unionBy(
        this.stackedCreatives,
        this.selectedCreatives,
        'id',
      )
      this.selectedCreatives = []
      this.$emit(
        'input',
        this.stackedCreatives.map(Form.CreativeSchduleCreativeFormModel.assign),
      )
    },
    instantStackItem(item) {
      this.isSelected(item) || this.selectItem(item)
      this.stackSelectedCreatives()
    },
    unstackSelectedCreatives() {
      this.stackedCreatives = differenceBy(
        this.stackedCreatives,
        this.selectedCreatives,
        'id',
      )
      this.selectedCreatives = []
      this.$emit(
        'input',
        this.stackedCreatives.map(Form.CreativeSchduleCreativeFormModel.assign),
      )
    },
    instantUnstackItem(item) {
      this.isSelected(item) || this.selectItem(item)
      this.unstackSelectedCreatives()
    },
    unstackAllCreatives() {
      // ツールチップを閉じる
      this.$refs.unstackButton.runDelay('close')

      this.stackedCreatives = []
      this.selectedCreatives = []
      this.$emit('input', [])
    },
    async fetchCreatives() {
      if (!this.creativeFolder) return
      try {
        this.loadingChoices = true
        this.creatives = await this.creativeFolder.getCreatives({
          creativeTypes: this.creativeTypes,
        })
      } catch (e) {
        console.error(e)
        throw new Error('クリエイティブ一覧の取得に失敗しました。')
      } finally {
        this.loadingChoices = false
      }
    },
    async fetchStackedCreatives() {
      if (this.value.length === 0) return
      try {
        this.loadingStack = true
        this.stackedCreatives = await CreativeRepository.findByIdsWithFolderInfo(
          this.value,
        )
      } catch (e) {
        console.error(e)
        throw new Error('配信クリエイティブの取得に失敗しました。')
      } finally {
        this.loadingStack = false
      }
    },
    reloadCreatives() {
      this.fetchCreatives()
      this.$emit('reload')
    },
  },
}
</script>

<style scoped lang="scss"></style>
